<template>
  <section class="module-regions">
    <div class="container">
      <Skeletor class="headline" width="100%" height="60" />
    </div>
    <div class="module-boxes">
      <div class="container">
        <div class="columns">
          <div class="column inline-box">
            <Skeletor class="mb-box" width="100%" height="570" />
          </div>
          <div class="column inline-box">
            <Skeletor class="mb-box" width="100%" height="570" />
          </div>
          <div class="column inline-box">
            <Skeletor class="mb-box" width="100%" height="570" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss"></style>
